import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { baseUrl } from '../../baseUrl'
import axios from 'axios'
import moment from 'moment'
import PDFViewer from '../utility/PDFViewer'
import { useAuth } from '../../AuthContext'
import { toast } from 'react-toastify'

const SingleCourse = () => {
    const params = useParams()

    const [course, setCourse] = useState(null)
    const [loading, setLoading] = useState(true);
    const { user } = useAuth()
    const [enrolled,setEnrolled]=useState(false)

    const isNotSellable = course?.courseID === "neet-flexi-test";
    const isFreeCourse = course?.courseID === "neet-pyq-practice";

    const handleBuy = async (amount, studentId, courseId) => {
        const merchantName = 'test'
        const merchantMobileNumber = 1234567890

        if(!studentId || !courseId || !amount){
            toast.error('something went wrong')
            return
        }

        try {
            const res = await axios.post(`${baseUrl}/payment/buy-course`, { amount, studentId, courseId, merchantMobileNumber, merchantName })
            window.location.href = res.data.url;
        } catch (error) {
            console.log(error)
        }
    }

    const handleSubscribe = async () => {
    if (!user?.id || !course?._id) {
        toast.error("Login required");
        return;
    }

    try {
        const res = await axios.post(`${baseUrl}/student/enroll-free-course`, {
            studentId: user.id,
            courseId: course._id
        });

        if (res.data.success) {
            toast.success("Subscribed successfully!");
            setEnrolled(true);
        }
    } catch (err) {
        console.log(err);
        toast.error("Something went wrong");
    }
};

    const checkEnrolled = async () => {
        try{
            const res = await axios.get(`${baseUrl}/student/check-enrolled-course?courseId=${course?._id}&studentId=${user?.id}`)
            if(res.data.isEnrolled){
                setEnrolled(true)
            } else{
                setEnrolled(false)
            }
        }
        catch(err){
            setEnrolled(false)
            console.log(err)
        }
    }
useEffect(() => {
    setLoading(true);

    axios.get(`${baseUrl}/course/get?id=${params.courseID}`)
        .then(res => {
            if (res.data && Object.keys(res.data).length > 0) {
                setCourse(res.data);
            } else {
                setCourse(null);
            }
        })
        .catch(() => setCourse(null))
        .finally(() => setLoading(false));
}, [params.courseID]);


    useEffect(()=>{
        checkEnrolled()
    },[course,user, params.courseID])

    if (loading) {
    return <div className="text-center mt-5">Loading...</div>;
}

if (!course || course?.active === false) {
    return (
        <div style={{ minHeight: "100vh" }} className="d-flex justify-content-center align-items-center">
            <div className="text-center">
                <h2>🚧 Coming Soon</h2>
                <p>This course is not available yet.</p>
            </div>
        </div>
    );
}

    return (
        <>
        { course &&
        <div style={{ minHeight: '100vh' }}>
            <section className="page-wrapper edutim-course-single">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="course-single-header">

                                <h3 className="single-course-title">{course.title}</h3>

                                <div className="single-course-meta ">
                                    <ul>

                                        {course?.type!=="Dynamic"&&<li>
                                            <span><i className="fa fa-bookmark"></i>{course.className}</span>
                                        </li>}
                                        <li>
                                            <span><i className="fa fa-bookmark"></i>{course.duration}</span>
                                        </li>
                                        <li>
                                            <span><i className="fa fa-clock"></i>from {moment(course.startDate).format('MMMM Do YYYY')}</span>
                                        </li>
                                        <li>
                                            <span><i className="fa fa-clock"></i>to {moment(course.endDate).format('MMMM Do YYYY')}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className="single-course-details ">
                                <h4 className="course-title">Description</h4>
                                <p>{course.description}</p>


                            </div>
                            <h4 className='course-title mt-3 mb-0'>Syllabus</h4>
                            {course.syllabus && <PDFViewer fileUrl={`${course.syllabus}`} />}
                        </div>

                        <div className="col-lg-4">
                            <div className="course-sidebar">
                                <div className="course-single-thumb">
                                    <img src={`${process.env.REACT_APP_API_URL}${course.image}`} alt="" className="img-fluid w-100" />
                                    <div className="course-price-wrapper">
                                        <div className="course-price ml-3"><h4>Price: <span className='fs-4 mr-4 ml-2 text-decoration-line-through '>{`₹${course.originalPrice}`}</span><span className='fs-3'>{`₹${course.price}`}</span></h4></div>
                                        {
                                            isNotSellable ? (
                                                <div className="buy-btn">
                                                    <span className="btn btn-secondary btn-block">
                                                        Free On Topic Wise Practice
                                                    </span>
                                                </div>
                                            ) : isFreeCourse ? (
                                                enrolled ? (
                                                    <div className="buy-btn">
                                                        <span className="btn btn-main btn-block">Enrolled</span>
                                                    </div>
                                                ) : user ? (
                                                    <div className="buy-btn">
                                                        <span
                                                            onClick={handleSubscribe}
                                                            className="btn btn-success btn-block"
                                                        >
                                                            Subscribe for Free
                                                        </span>
                                                    </div>
                                                ) : (
                                                    <Link to="/login">
                                                        <div className="buy-btn">
                                                            <span className="btn btn-main btn-block">Login to Subscribe</span>
                                                        </div>
                                                    </Link>
                                                )
                                            ) : enrolled ? (
                                                <div className="buy-btn">
                                                    <span className="btn btn-main btn-block">Enrolled</span>
                                                </div>
                                            ) : user ? (
                                                <div className="buy-btn">
                                                    <span
                                                        onClick={() => handleBuy(course.price, user.id, course._id)}
                                                        className="btn btn-main btn-block"
                                                    >
                                                        Buy This Course
                                                    </span>
                                                </div>
                                            ) : (
                                                <Link to="/login">
                                                    <div className="buy-btn">
                                                        <span className="btn btn-main btn-block">Login to buy</span>
                                                    </div>
                                                </Link>
                                            )
                                        }
                                    </div>
                                </div>


                                <div className="course-widget single-info">
                                    <i className="bi bi-group"></i>
                                    <span>Number of tests : {course?.type==="Dynamic" ? "Unlimited" : course.tests}</span>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>}
        </>
    )
}

export default SingleCourse
